import { Component, OnChanges, OnDestroy, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { SeriesLabels } from '@progress/kendo-angular-charts';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { PhBhpReportObserveComponent } from './ph-bhp-report-observe.component';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { SopDetail } from '../Models/SopDetail';
import { PhBhpPdfSopReportComponent } from '../ph-bhp-pdf-sop-report/ph-bhp-pdf-sop-report.component';
import { fiveMomentsMap, asepticProcedures } from '../ph-bhp-asepticprocedures.service';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-ph-bhp-report-sop',
  templateUrl: './ph-bhp-report-sop.component.html',
  styleUrls: ['./ph-bhp-report-sop.component.css']
})
export class PhBhpReportSopComponent implements OnChanges, OnDestroy {
  benchMark2Txt: string;
  benchMark2AllDept: string;
  benchMark1Txt: string;
  benchMark1AllDept: string;
  filter1Txt: string;
  filter2Txt: string;
  filter1AllDept: string;
  filter2AllDept: string;
  filter1Text: string;
  filter2Text: string;
  benchMarkText: string;
  benchMark1Text: string;
  benchMark2Text: string;
  subscription: Subscription;
  subscriptionPackage: Subscription;
  gridData: any;
  searchText: any;
  fields = [];
  actionItems: any;
  public anotherArra = [];
  @Output() childData = new EventEmitter();
  @Input() userData;
  roleId;
  packageID;
  isObserve: boolean;
  isSOP: boolean;
  isCheck: boolean;
  @ViewChild('frequencyChart') frequencyChart;
  @ViewChild('processComplianceChart') processComplianceChart;
  @ViewChild('subStepProcessChart') subStepProcessChart;
  @ViewChild('predefinedCommentsChart') predefinedCommentsChart;
  @ViewChild('overallComplianceChart') overallComplianceChart;
  @ViewChild('fiveMomentsFilterChart') fiveMomentsFilterChart;
  @ViewChild('asepticProceduresFilterChart') asepticProceduresFilterChart;
  @ViewChild('observeCommentsFilterChart') observeCommentsFilterChart;
  @ViewChild('sopReportExport', { static: true }) sopReportExport: PhBhpPdfSopReportComponent;
  showSopReportExport = false;
  noDataFound: boolean = false;
  nofrequencyFound: boolean = false;
  nosubprocessFound: boolean = false;
  nocommentsFound: boolean = false;
  checkFilter2: boolean = false
  showsecondfilter: boolean = false
  predefinedComments
  frequencyDistribution;
  processCompliance;
  subStepProcessCompliance;
  frequencyDistributionFilter: any;
  processComplianceFilter: any;
  subStepProcessComplianceFilter: any;
  predefinedCommentsFilter: any;
  sopDetail: SopDetail[];
  frequencySopTittle: string;
  processComplianceSopTittle: string;
  subStepProcessComplianceSopTittle: string;
  predefinedCommentsSopTittle: string;

  overallCompliance;
  overallComplianceFilter;
  overallComplianceSopTitle;

  noOverallCompliance: boolean = false;

  fiveMoments;
  fiveMomentsFilter;
  fiveMomentsSopTitle;
  dataMoments = [];
  nofiveMomentsFilter: boolean = false;
  fiveMomentsMap: any[];

  asepticStatistics;
  asepticStatisticsFilter;
  noAsepticProcedures: boolean = false;
  asepticDataMoments = [];
  asepticProcedures = asepticProcedures;

  observeComments;
  observeCommentsFilter;
  noObserveComments: boolean = false;

  commentTranslations;

  showCharts: boolean;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  maxFilters = 0;

  pageInfoFrquency = {
    items: 'EVALUATION.COMMENTS',
    itemsPerPageLabel: 'EVALUATION.PER_PAGE.COMMENTS'
  };
  fieldsFrequency: Array<any> = [];
  gridDataFrequency: Array<any> = [];
  public clickExcelBtn = false;

  constructor(private service: PHBHPFeaturePackageEvaluationService,
    public layoutService: PHBHPLayoutPackageService,
    public router: Router) {
    this.benchMark2Txt = this.layoutService.translateText('DASHBOARD.BENCHMARK') + " 2 - ";
    this.benchMark2AllDept = this.layoutService.translateText('DASHBOARD.BENCHMARK') + " 2 - " + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');
    this.benchMark1Txt = this.layoutService.translateText('DASHBOARD.BENCHMARK') + " 1 - ";
    this.benchMark1AllDept = this.layoutService.translateText('DASHBOARD.BENCHMARK') + " 1 - " + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');
    this.filter1Txt = this.layoutService.translateText('EVALUATION.FILTER') + " 1 - ";
    this.filter2Txt = this.layoutService.translateText('EVALUATION.FILTER') + " 2 - ";
    this.filter1AllDept = this.layoutService.translateText('EVALUATION.FILTER') + " 1 - " + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');
    this.filter2AllDept = this.layoutService.translateText('EVALUATION.FILTER') + " 2 - " + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');
    this.filter1Text = this.layoutService.translateText('EVALUATION.FILTER') + " 1";
    this.filter2Text = this.layoutService.translateText('EVALUATION.FILTER') + " 2";
    this.benchMarkText = this.layoutService.translateText('DASHBOARD.BENCHMARK');
    this.benchMark1Text = this.layoutService.translateText('DASHBOARD.BENCHMARK') + " 1";
    this.benchMark2Text = this.layoutService.translateText('DASHBOARD.BENCHMARK') + " 2";
  }

  ngOnChanges() {
    if (this.userData) {
      this.sopReportExport.printChart = true;
      var userId = this.userData.userId;
      this.roleId = this.userData.roleName.roleId;
      this.packageID = this.layoutService.packageID;
      this.checkEvalMode();
      this.layoutService.showLoader = true;
      var sopDetail: Observable<Array<SopDetail>> = this.service.getSOPDetails(userId);
      var summarisedReport: Observable<any> = this.service.getSummarisedReport(userId, this.roleId);
      forkJoin([sopDetail, summarisedReport]).subscribe(([sopDetailRes, summarisedReportRes]) => {
        this.layoutService.showLoader = false;
        this.sopDetail = sopDetailRes;
        this.frequencyDistribution = summarisedReportRes.frequencyDistributionWithFilter;
        this.processCompliance = summarisedReportRes.processComplianceWithFilter;
        this.subStepProcessCompliance = summarisedReportRes.subStepProcessComplianceWithFilter;
        this.predefinedComments = summarisedReportRes.sopObservationPredefinedCommentsWithFilter;

        this.overallCompliance = summarisedReportRes.observeEvaluationOverAllComplianceResults
        this.fiveMoments = summarisedReportRes.observeEvaluationFiveMomentResults;
        this.asepticStatistics = summarisedReportRes.observeEvaluationAsepticProcedureResults;
        this.observeComments = summarisedReportRes.observeEvaluationCommentsResults;

        this.getSOPReport();
        this.getObserveReports();
      }, (error) => { this.layoutService.showLoader = false; });

      this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
        const url = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([url]).then(() => { });
        });
      })

      this.service.getPredefinedCommentsTranslations().subscribe((res) => {
        this.commentTranslations = res;
      });
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getSOPReport() {
    if (this.frequencyDistribution && this.frequencyDistribution.length > 0 && this.frequencyDistribution[0].subStepProcessComplianceMainList !== null) {
      if (this.frequencyDistribution[0].sopFilters && this.frequencyDistribution[0].sopFilters.length > 0) {
        this.frequencyDistributionFilter = this.frequencyDistribution[0].sopFilters[0];
        this.sopReportExport.frequencyDistributionFilter = this.frequencyDistributionFilter
      }
      this.buildFrequencyChart(this.frequencyDistribution[0].subStepProcessComplianceMainList);
      setTimeout(() => {
        if (this.nofrequencyFound) return;
        this.selectFrequencyChartSeries(this.frequencyDistributionFilter);
      }, 1000);
    } else {
      if (this.frequencyDistribution == null) {
        this.nofrequencyFound = true;
        this.frequencyChart.noDataFound = true;
        this.sopReportExport.frequencyDistributionNoDataFound = true;
      } else {
        if (this.frequencyDistribution[0].subStepProcessComplianceMainList == null) {
          this.nofrequencyFound = true;
          this.frequencyChart.noDataFound = true;
          this.sopReportExport.frequencyDistributionNoDataFound = true;
        } else {
          this.nofrequencyFound = false;
          this.frequencyChart.noDataFound = false;
          this.sopReportExport.frequencyDistributionNoDataFound = false;
        }
      }
      this.sopReportExport.chartOptionsFrequency = JSON.parse(JSON.stringify(this.frequencyChart.chartOptions));
      this.sopReportExport.breakChartAll();
    }
    if (this.processCompliance && this.processCompliance.length > 0) {
      if (this.processCompliance[0].sopFilters && this.processCompliance[0].sopFilters.length > 0) {
        this.processComplianceFilter = this.processCompliance[0].sopFilters[0];
        this.sopReportExport.processComplianceFilter = this.processComplianceFilter
      }
      this.buildProcessComplianceChart(this.processCompliance[0].processComplianceMainList);
      setTimeout(() => {
        if (this.nosubprocessFound) return;
        this.selectProcessComplianceSeries(this.processComplianceFilter);
      }, 1000)
    } else {
      if (this.processCompliance == null) {
        this.noDataFound = true;
        this.processComplianceChart.noDataFound = true;
        this.sopReportExport.processComplianceNoDataFound = true;
      } else {
        this.noDataFound = false;
        this.processComplianceChart.noDataFound = false;
        this.sopReportExport.processComplianceNoDataFound = false;
      }
      this.sopReportExport.chartOptionsProcess = JSON.parse(JSON.stringify(this.processComplianceChart.chartOptions));
      this.sopReportExport.breakChartAll();
    }
    if (this.subStepProcessCompliance && this.subStepProcessCompliance.length > 0) {
      if (this.subStepProcessCompliance[0].sopFilters && this.subStepProcessCompliance[0].sopFilters.length > 0) {
        this.subStepProcessComplianceFilter = this.subStepProcessCompliance[0].sopFilters[0];
        this.sopReportExport.subStepProcessComplianceFilter = this.subStepProcessComplianceFilter
      }
      this.buildSubStepProcessComplianceChart(this.subStepProcessCompliance[0].subStepProcessComplianceMainList);
      setTimeout(() => {
        if (this.nosubprocessFound) return;
        this.selectSubStepProcessComplianceSeries(this.subStepProcessComplianceFilter);
      }, 1000);
    } else {
      if (this.subStepProcessCompliance == null) {
        this.nosubprocessFound = true;
        this.subStepProcessChart.noDataFound = true;
        this.sopReportExport.subProcessNoDataFound = true;
      } else {
        this.nosubprocessFound = false;
        this.subStepProcessChart.noDataFound = false;
        this.sopReportExport.subProcessNoDataFound = false;
      }
      this.sopReportExport.chartOptionsSubstep = JSON.parse(JSON.stringify(this.subStepProcessChart.chartOptions));
      this.sopReportExport.breakChartAll()
    }

    if (this.predefinedComments && this.predefinedComments.length > 0) {
      if (this.predefinedComments[0].commentFilters && this.predefinedComments[0].commentFilters.length > 0) {
        this.predefinedCommentsFilter = this.predefinedComments[0].commentFilters[0];
        this.sopReportExport.predefinedCommentsFilter = this.predefinedCommentsFilter

      }
      this.buildpredefinedCommentsChart(this.predefinedComments[0].sopObservationPredefinedCommentsMainList);
      setTimeout(() => {
        if (this.nocommentsFound) return;
        this.selectCommentSeries(this.predefinedCommentsFilter);
      }, 1000);
    } else {
      if (this.predefinedComments == null) {
        this.nocommentsFound = true;
        this.predefinedCommentsChart.noDataFound = true;
        this.sopReportExport.sopCommentsNoDataFound = true;
      } else {
        this.nocommentsFound = false;
        this.predefinedCommentsChart.noDataFound = false;
        this.sopReportExport.sopCommentsNoDataFound = false;
      }
      this.sopReportExport.chartOptionsComments = JSON.parse(JSON.stringify(this.predefinedCommentsChart.chartOptions));
      this.sopReportExport.breakChartAll();
    }
  }

  getObserveReports() {
    this.asepticDataMoments = []
    asepticProcedures.forEach(val => {
      this.asepticDataMoments.push(this.layoutService.translateText(val.value));
    });
    this.dataMoments = [];
    this.fiveMomentsMap = fiveMomentsMap;
    fiveMomentsMap.forEach(val => {
      this.dataMoments.push(val.short);
    });

    if (this.overallCompliance) {
      if (this.overallCompliance.overAllComplianceFilter) {
        this.overallComplianceFilter = this.overallCompliance.overAllComplianceFilter;
        this.sopReportExport.overallComplianceFilter = this.overallComplianceFilter
      }
      this.buildOverallComplianceChart(this.overallCompliance.observeEvaluationOverAllComplianceResultList);
      setTimeout(() => {
        if (this.noOverallCompliance) return;
        this.selectOverallComplianceSeries(this.overallComplianceFilter);
      }, 1000);
    } else {
      if (this.overallCompliance == null) {
        this.overallComplianceChart.noDataFound = true;
        this.noOverallCompliance = true;
        this.sopReportExport.overallComplianceNoDataFound = true;
      } else {
        this.noOverallCompliance = false;
        this.overallComplianceChart.noDataFound = false;
        this.sopReportExport.overallComplianceNoDataFound = false;
      }
      this.sopReportExport.chartOverallCompliance = JSON.parse(JSON.stringify(this.overallComplianceChart.chartOptions));
      this.sopReportExport.breakChartAll();
    }

    if (this.fiveMoments) {
      if (this.fiveMoments.fiveMomentFilter) {
        this.fiveMomentsFilter = this.fiveMoments.fiveMomentFilter;
        this.sopReportExport.fiveMomentsFilter = this.fiveMomentsFilter
        if (this.fiveMomentsFilter.fiveMomentsShown) {
          this.fiveMomentsMap = this.fiveMomentsMap.map(moment => ({ ...moment, checked: this.fiveMomentsFilter.fiveMomentsShown[moment.key] }));
          this.fiveMoments.observationFiveMomentTables = this.fiveMoments.observationFiveMomentTables.filter(table => {
            return this.fiveMomentsMap.some(moment => moment.name === table.name && moment.checked);
          });
        }
      }

      this.buildFiveMomentsChart(this.fiveMoments.observeEvaluationFiveMomentResultList);
      setTimeout(() => {
        if (this.nofiveMomentsFilter) return;
        this.selectFiveMomentsSeries(this.fiveMomentsFilter);
      }, 2500);
    } else {
      if (this.fiveMoments == null) {
        this.nofiveMomentsFilter = true;
        this.fiveMomentsFilterChart.noDataFound = true;
        this.sopReportExport.fiveMomentsNoDataFound = true;
      } else {
        this.nofiveMomentsFilter = false;
        this.fiveMomentsFilterChart.noDataFound = false;
        this.sopReportExport.fiveMomentsNoDataFound = false;
      }
      this.sopReportExport.chartFiveMoments = JSON.parse(JSON.stringify(this.fiveMomentsFilterChart.chartOptions));
      this.sopReportExport.breakChartAll();
    }

    if (this.asepticStatistics) {
      if (this.asepticStatistics.asepticFilter) {
        this.asepticStatisticsFilter = this.asepticStatistics.asepticFilter;
        this.sopReportExport.asepticProceduresFilter = this.asepticStatisticsFilter;
        if (this.asepticStatisticsFilter.asepticProceduresShown) {
          this.asepticProcedures.forEach(procedure => {
            procedure.checked = this.asepticStatisticsFilter.asepticProceduresShown.includes(procedure.id);
          });
          this.asepticStatistics.observationAsepticProcedureTables = this.asepticStatistics.observationAsepticProcedureTables.filter(table => {
            return this.asepticProcedures.some(procedure => procedure.value === table.name && procedure.checked);
          });
        }
      }

      this.buildAsepticStatisticsFilterChart(this.asepticStatistics.observeEvaluationAsepticProcedureList);
      setTimeout(() => {
        if (this.noAsepticProcedures) return;
        this.selectStaticsBeforeAsepticSeries(this.asepticStatisticsFilter);
      }, 1000);
    } else {
      if (this.asepticStatistics == null) {
        this.noAsepticProcedures = true;
        this.asepticProceduresFilterChart.noDataFound = true;
        this.sopReportExport.asepticProceduresNoDataFound = true;
      } else {
        this.noAsepticProcedures = false;
        this.asepticProceduresFilterChart.noDataFound = false;
        this.sopReportExport.asepticProceduresNoDataFound = false;
      }
      this.sopReportExport.chartAsepticProcedures = JSON.parse(JSON.stringify(this.asepticProceduresFilterChart.chartOptions));
      this.sopReportExport.breakChartAll();
    }

    if (this.observeComments) {
      if (this.observeComments.commentFilters) {
        this.observeCommentsFilter = this.observeComments.commentFilters;
        this.sopReportExport.observeCommentsFilter = this.observeCommentsFilter;
      }
      this.buildObservePredefinedCommentsChart(this.observeComments.observationPredefinedCommentsResultList)
    } else {
      if (this.observeComments == null) {
        this.noObserveComments = true;
        this.sopReportExport.observeCommentsNoDataFound = true;
      } else {
        this.noObserveComments = false;
        this.sopReportExport.observeCommentsNoDataFound = false;
      }
      this.sopReportExport.chartObserveComments = JSON.parse(JSON.stringify(this.observeCommentsFilterChart.chartOptions));
    }

    this.assignSopTittle();
  }

  assignSopTittle() {
    var frequencySopiDs = 0;
    var processComplianceSopiDs = [];
    var subStepProcessComplianceSopiDs = 0;
    var predefinedCommentsSopiDs = [];
    this.frequencySopTittle = undefined;
    this.processComplianceSopTittle = undefined;
    this.subStepProcessComplianceSopTittle = undefined;
    this.predefinedCommentsSopTittle = undefined;
    if (this.frequencyDistributionFilter) {
      frequencySopiDs = this.frequencyDistributionFilter.sopiDs;
    }
    if (this.processComplianceFilter) {
      processComplianceSopiDs = this.processComplianceFilter.sopiDs.split(",");
      if (processComplianceSopiDs.length > 1) {
        this.processComplianceSopTittle = this.layoutService.translateText("EVALUATION.All.SOP");
      }
    }
    if (this.subStepProcessComplianceFilter) {
      subStepProcessComplianceSopiDs = this.subStepProcessComplianceFilter.sopiDs;
    }
    if (this.predefinedCommentsFilter) {
      predefinedCommentsSopiDs = this.predefinedCommentsFilter.sopiDs.split(",");
      if (processComplianceSopiDs.length > 1) {
        this.predefinedCommentsSopTittle = this.layoutService.translateText("EVALUATION.All.SOP");
      }
    }
    this.sopDetail.forEach((sop) => {
      if (sop.sopid == frequencySopiDs && !this.frequencySopTittle) {
        this.frequencySopTittle = sop.title;
      }
      if (sop.sopid == subStepProcessComplianceSopiDs && !this.subStepProcessComplianceSopTittle) {
        this.subStepProcessComplianceSopTittle = sop.title;
      }
      if (sop.sopid == processComplianceSopiDs[0] && !this.processComplianceSopTittle) {
        this.processComplianceSopTittle = sop.title;
      }
      if (sop.sopid == processComplianceSopiDs[0] && !this.predefinedCommentsSopTittle) {
        this.predefinedCommentsSopTittle = sop.title;
      }
      if (this.frequencySopTittle && this.processComplianceSopTittle && this.subStepProcessComplianceSopTittle && this.predefinedCommentsSopTittle) {
        return;
      }
    })
    this.sopReportExport.frequencySopTittle = this.frequencySopTittle
    this.sopReportExport.processComplianceSopTittle = this.processComplianceSopTittle
    this.sopReportExport.subStepProcessComplianceSopTittle = this.subStepProcessComplianceSopTittle
    this.sopReportExport.predefinedCommentsSopTittle = this.predefinedCommentsSopTittle
  }

  buildpredefinedCommentsChart(res) {
    let data = JSON.parse(JSON.stringify(this.predefinedCommentsChart.chartOptions));
    let dataSet = 0;
    let dataSetsName = this.layoutService.translateText('EVALUATION.DATA_SETS');
    data.categoryAxis.categories = [];
    data.series = [];

    let filterCount = 0;
    let benchmarkCount = 0;

    for (let i = 0; i < res.length; i++) {
      const predefinedCommentsList = res[i].sopObservationPredefinedCommentsList;
      for (let j = 0; j < predefinedCommentsList.length; j++) {
        const predefinedComment = predefinedCommentsList[j];
        if (new RegExp(this.commentTranslations.jewelleryComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.jewelleryComments.length; k++) {
            res[i].sopObservationPredefinedCommentsList[j].commentName = res[i].sopObservationPredefinedCommentsList[j].commentName.replace(this.commentTranslations.jewelleryComments[k], this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH'))
          }
        }
        if (new RegExp(this.commentTranslations.nailComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.nailComments.length; k++) {
            res[i].sopObservationPredefinedCommentsList[j].commentName = res[i].sopObservationPredefinedCommentsList[j].commentName.replace(this.commentTranslations.nailComments[k], this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH'))
          }
        }
        if (new RegExp(this.commentTranslations.desinfectionComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.desinfectionComments.length; k++) {
            res[i].sopObservationPredefinedCommentsList[j].commentName = res[i].sopObservationPredefinedCommentsList[j].commentName.replace(this.commentTranslations.desinfectionComments[k], this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED'))
          }
        }
        if (new RegExp(this.commentTranslations.antisepsisComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.antisepsisComments.length; k++) {
            res[i].sopObservationPredefinedCommentsList[j].commentName = res[i].sopObservationPredefinedCommentsList[j].commentName.replace(this.commentTranslations.antisepsisComments[k], this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED'))
          }
        }
        if (new RegExp(this.commentTranslations.processComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.processComments.length; k++) {
            res[i].sopObservationPredefinedCommentsList[j].commentName = res[i].sopObservationPredefinedCommentsList[j].commentName.replace(this.commentTranslations.processComments[k], this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED'))
          }
        }
      }

    }
    const colors = [
      "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300",
    ];
    res = res.filter((item) => !item.isBenchMark);
    res.forEach((commentArray: any, index) => {
      dataSet = 0;
      data.series[index] = { data: [], name: [] };
      data.series[index].color = colors[index];

      if (commentArray.sopObservationPredefinedCommentsList.length === 0) {
        this.nocommentsFound = true;
        this.predefinedCommentsChart.noDataFound = true;
      } else {
        this.nocommentsFound = false;
        this.predefinedCommentsChart.noDataFound = false;
      }

      commentArray.sopObservationPredefinedCommentsList.forEach((comment: any) => {
        dataSet += comment.totalObservations;
        data.series[index].data.push(comment.predefinedCommentsPercentage);
        if (index == 0) {
          const title = this.layoutService.translateText(comment.commentName);
          data.categoryAxis.categories.push(title ? title : comment.commentName);

        }
      })

      if (commentArray.isBenchMark) {
        benchmarkCount++;
        data.series[index].name = [this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ${dataSet} ${dataSetsName}`];
      } else {
        filterCount++;
        data.series[index].name = [this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ${dataSet} ${dataSetsName}`];
      }
    });
    data.categoryAxis.rotation = 0;
    data.categoryAxis.maxDivisions = 10;
    this.predefinedCommentsChart.chartOptions = data;
    this.predefinedCommentsChart.chartDatamani();
    this.sopReportExport.chartOptionsComments = JSON.parse(JSON.stringify(data));
    this.sopReportExport.breakChartAll();
  }

  buildProcessComplianceChart(res) {
    var data = JSON.parse(JSON.stringify(this.processComplianceChart.chartOptions));
    let dataSet = 0;
    let dataSetsName = this.layoutService.translateText('EVALUATION.DATA_SETS');
    data.categoryAxis.categories = [];
    data.series = [];

    let filterCount = 0;
    let benchmarkCount = 0;
    res = res.filter((item) => !item.isBenchMark)
    const colors = [
      "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300",
    ];
    res.forEach((processComplianceArray: any, index) => {
      dataSet = 0;
      data.series[index] = { data: [], name: [] };
      data.series[index].color = colors[index];

      if (processComplianceArray.isBenchMark == false) {
        if (processComplianceArray.processComplianceList.length === 0) {
          this.noDataFound = true;
          this.processComplianceChart.noDataFound = true;
        } else {
          this.noDataFound = false;
          this.processComplianceChart.noDataFound = false;
        }
      }

      processComplianceArray.processComplianceList.forEach((processCompliance) => {
        dataSet += processCompliance.totalObservations;
        data.series[index].data.push(processCompliance.processCompliancePercentage);
        if (index == 0) {
          let title = this.layoutService.translateText(processCompliance.title)
          data.categoryAxis.categories.push(title ? title : processCompliance.title);
        }
      });

      if (processComplianceArray.isBenchMark) {
        benchmarkCount++;
        data.series[index].name = [this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ${dataSet} ${dataSetsName}`];
      } else {
        filterCount++;
        data.series[index].name = [this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ${dataSet} ${dataSetsName}`];
      }
    });

    data.categoryAxis.rotation = 0;
    data.categoryAxis.maxDivisions = 10;
    this.processComplianceChart.chartOptions = data;
    this.processComplianceChart.chartDatamani();
    this.gridData = res[0].processComplianceList
      // translate SOP titles
      .map(e => {
        // use object destructuring to create new objects and keep res[0].processComplianceList unchanged
        return { ...e, title: this.layoutService.translateText(e.title) }
      });

    if (res) {
      let nonBenchmarkFilters = res.filter(filter => !filter.isBenchMark);
      nonBenchmarkFilters.forEach((filter, index) => {
        let res2 = filter.processComplianceList;
        this.fields.push(
          { 'field': `totalCompliantObservationsforfilter${index + 1}`, 'title': 'EVALUATION.AMOUNT_COMPLIANT_OBSERVATIONS', 'group': `EVALUATION.FILTER_${index + 1}` },
          { 'field': `totalObservationsforfilter${index + 1}`, 'title': 'EVALUATION.TOTAL_AMOUNT_OBSERVATIONS', 'group': `EVALUATION.FILTER_${index + 1}` },
        );
        for (let i = 0; i < res2.length; i++) {
          if (this.gridData[i]) {
            this.gridData[i][`totalObservationsforfilter${index + 1}`] = res2[i]['totalObservations'];
            this.gridData[i][`totalCompliantObservationsforfilter${index + 1}`] = res2[i]['totalCompliantObservations'];
          }
        }
      });
    }
    this.maxFilters = this.getMaxFilters(this.gridData);
    this.sopReportExport.gridData = this.gridData;
    this.sopReportExport.maxFilters = this.maxFilters;
    this.changeLangProcessPage();
    this.checkFilter2 = !this.checkFilter2;
    this.sopReportExport.chartOptionsProcess = JSON.parse(JSON.stringify(data));
    this.sopReportExport.breakChartAll();

    this.fieldsFrequency = [];
    this.fieldsFrequency.push({ 'field': 'title', 'title': 'DASHBOARD.PROCESS' });
    this.fieldsFrequency.push({ 'field': 'processCompliancePercentage', 'title': this.layoutService.translateText('DASHBOARD.PROCESS_COMPLIANCE') + '%' }
    );
    for (let i = 0; i < this.maxFilters; i++) {
      let item = {};
      item['field'] = 'totalCompliantObservationsforfilter' + (i + 1);
      item['title'] = 'EVALUATION.FILTER_' + (i + 1) + '.AMOUNT_COMPLIANT_OBSERVATIONS';
      this.fieldsFrequency.push(item);
      item = {};
      item['field'] = 'totalObservationsforfilter' + (i + 1);
      item['title'] = 'EVALUATION.FILTER_' + (i + 1) + '.TOTAL_AMOUNT_OBSERVATIONS';
      this.fieldsFrequency.push(item);
    }
    this.gridDataFrequency = this.gridData.map((item, i) => {
      let newItem = {};
      this.fieldsFrequency.forEach((field) => {
        newItem[field.field] = item[field.field];
      });
      return newItem;
    });

    //this.sopReportExport.processComplianceChart.chartOptions = data;
    // this.sopReportExport.breakChartProcess();
    // this.sopReportExport.processComplianceChart.chartDatamani();

  }

  buildOverallComplianceChart(observeEvaluationOverAllComplianceResultList) {
    let data = JSON.parse(JSON.stringify(this.overallComplianceChart.chartOptions));
    let filterCount: number = 0;
    let benchmarkCount: number = 0;
    let atLeastOneColumnHasData = false;

    data.categoryAxis.categories = [];
    data.series = [];

    if (!observeEvaluationOverAllComplianceResultList || observeEvaluationOverAllComplianceResultList.length === 0) {
      this.noOverallCompliance = true;
      return;
    } else {
      this.noOverallCompliance = false;
    }

    var isBenchmark = false;
    for (const overallComplianceArray of observeEvaluationOverAllComplianceResultList) {
      if (overallComplianceArray.isBenchMark) {
        isBenchmark = true;
        break;
      }
    }

    var colors = [];
    if (isBenchmark) {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    } else {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    }

    observeEvaluationOverAllComplianceResultList.forEach((overallComplianceArray: any, index) => {
      if (index == 0) {
        data.categoryAxis.categories.push(this.layoutService.translateText("DASHBOARD.TOTAL_PERCENT_COMPLIANCE"));
      }
      overallComplianceArray.observeEvaluationOverAllComplianceResult.forEach((overallCompliance: any) => {
        if (overallComplianceArray.isBenchMark) {
          benchmarkCount++;
          const name = overallCompliance.departmentName !== null ?
            this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ` + this.layoutService.translateText(overallCompliance.departmentName) :
            this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ` + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');

          data.series.push({
            data: [overallCompliance.positivePerformedAction],
            name: name,
            type: 'column',
            color: colors[index]
          });
        } else {
          filterCount++;
          const name = overallCompliance.departmentName !== null ?
            this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ` + this.layoutService.translateText(overallCompliance.departmentName) :
            this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ` + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');

          data.series.push({
            data: [overallCompliance.positivePerformedAction],
            name: name,
            type: 'column',
            color: colors[index]
          });
        }
      });
      if (!overallComplianceArray.isBenchMark) {
        var columHasData = overallComplianceArray.observeEvaluationOverAllComplianceResult[0].positivePerformedAction > 0
        atLeastOneColumnHasData = atLeastOneColumnHasData || columHasData;
      }

    });

    this.noOverallCompliance = !atLeastOneColumnHasData;
    this.overallComplianceChart.noDataFound = !atLeastOneColumnHasData;


    data.seriesDefaults.style = "smooth";
    data.categoryAxis.rotation = 0;
    data.categoryAxis.maxDivisions = 10;

    this.overallComplianceChart.chartOptions = data;
    this.overallComplianceChart.chartDatamani();
    this.sopReportExport.chartOverallCompliance = JSON.parse(JSON.stringify(data));
    this.sopReportExport.breakChartAll();
  }

  buildFiveMomentsChart(observeEvaluationFiveMomentResultList) {
    let name: string;
    let filterCount: number = 0;
    let benchmarkCount: number = 0;
    let data = JSON.parse(JSON.stringify(this.fiveMomentsFilterChart.chartOptions));

    data.categoryAxis.categories = [];
    data.series = [];

    if (!observeEvaluationFiveMomentResultList || observeEvaluationFiveMomentResultList.length === 0) {
      this.nofiveMomentsFilter = true;
      this.fiveMomentsFilterChart.noDataFound = true;
      return;
    } else {
      this.nofiveMomentsFilter = false;
      this.fiveMomentsFilterChart.noDataFound = false;
    }

    var isBenchmark = false;
    for (const fiveMomentsArray of observeEvaluationFiveMomentResultList) {
      if (fiveMomentsArray.isBenchMark) {
        isBenchmark = true;
        break;
      }
    }

    var colors = [];
    if (isBenchmark) {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    } else {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    }

    observeEvaluationFiveMomentResultList.forEach((fiveMomentsArray: any, index) => {
      if (index == 0) {
        this.fiveMomentsMap.forEach(moment => {
          if (moment.checked) {
            data.categoryAxis.categories.push(this.layoutService.translateText(moment.short));
          }
        });
      }
      fiveMomentsArray.observeEvaluationFiveMomentResult.forEach((fiveMoment: any) => {
        if (fiveMomentsArray.isBenchMark) {
          benchmarkCount++;
          name = fiveMoment.departmentName !== null ?
            this.layoutService.translate.instant('EVALUATION.BENCHMARK') + ` ${benchmarkCount} - ` + this.layoutService.translateText(fiveMoment.departmentName) :
            this.layoutService.translate.instant('EVALUATION.BENCHMARK') + ` ${benchmarkCount} - ` + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');
        } else {
          filterCount++;
          name = fiveMoment.departmentName !== null ?
            this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ` + this.layoutService.translateText(fiveMoment.departmentName) :
            this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ` + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');
        }
        fiveMoment = this.correctNaNMoments(fiveMoment);
        let momentData = [];
        this.fiveMomentsMap.forEach(moment => {
          if (moment.checked) {
            momentData.push(fiveMoment[moment.key]);
          }
        });
        data.series.push({
          data: momentData,
          name: name,
          type: 'column',
          color: colors[index],
          width: 20
        });
      });

      // if the second result hasn't results, the report is not showed
      // the second result can be benchmark or not
      // if (!fiveMomentsArray.isBenchMark) {
      //   let fmr = fiveMomentsArray.observeEvaluationFiveMomentResult[0];
      //   const hasResults = fmr.beforeTouchingPatient || fmr.beforeAsepticProcdures || fmr.afterBodyFluidExposure || fmr.afterTouchingPatient || fmr.afterTouchingPatientSurroundings;
      //   this.nofiveMomentsFilter = !hasResults;
      //   this.fiveMomentsFilterChart.noDataFound = !hasResults;
      // }
    });

    data.seriesDefaults.style = "smooth";
    data.seriesDefaults.labels = { visible: false }
    data.categoryAxis.rotation = 0;
    data.categoryAxis.maxDivisions = 10;
    if (data.series.length == 0) {
      this.nofiveMomentsFilter = true;
    }
    this.fiveMomentsFilterChart.chartOptions = data;
    this.fiveMomentsFilterChart.chartDatamani();
    this.fiveMomentsFilterChart.findTooltipText = (truncatedText) => {
      const translateTruncated = this.layoutService.translateText(truncatedText);
      const tooltip = this.fiveMomentsUsingKeys(translateTruncated, 'short')
        ? this.layoutService.translateText(this.fiveMomentsUsingKeys(translateTruncated, 'short').name) : '';
      return tooltip;
    };
    this.sopReportExport.chartFiveMoments = JSON.parse(JSON.stringify(data));
    this.sopReportExport.breakChartAll();
  }

  private correctNaNMoments(fiveMoment: any) {
    if (isNaN(fiveMoment.beforeTouchingPatient)) {
      fiveMoment.beforeTouchingPatient = 0;
    }
    if (isNaN(fiveMoment.beforeAsepticProcdures)) {
      fiveMoment.beforeAsepticProcdures = 0;
    }
    if (isNaN(fiveMoment.afterBodyFluidExposure)) {
      fiveMoment.afterBodyFluidExposure = 0;
    }
    if (isNaN(fiveMoment.afterTouchingPatient)) {
      fiveMoment.afterTouchingPatient = 0;
    }
    if (isNaN(fiveMoment.afterTouchingPatientSurroundings)) {
      fiveMoment.afterTouchingPatientSurroundings = 0;
    }
    return fiveMoment;
  }

  fiveMomentsUsingKeys(shortName, key) {
    if (shortName != 0)
      return this.fiveMomentsMap.find(res => this.layoutService.translateText(res[key]) == shortName);
    return null;
  }

  buildAsepticStatisticsFilterChart(observeEvaluationAsepticProcedureList) {
    let name: string;
    let filterCount: number = 0;
    let benchmarkCount: number = 0;
    let data = JSON.parse(JSON.stringify(this.asepticProceduresFilterChart.chartOptions));

    data.categoryAxis.categories = [];
    data.series = [];

    if (!observeEvaluationAsepticProcedureList || observeEvaluationAsepticProcedureList.length === 0) {
      this.noAsepticProcedures = true;
      this.asepticProceduresFilterChart.noDataFound = true;
      return;
    } else {
      this.noAsepticProcedures = false;
      this.asepticProceduresFilterChart.noDataFound = false;
    }

    var isBenchmark = false;
    for (const asepticProcedureArray of observeEvaluationAsepticProcedureList) {
      if (asepticProcedureArray.isBenchMark) {
        isBenchmark = true;
        break;
      }
    }

    var colors = [];
    if (isBenchmark) {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    } else {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    }

    observeEvaluationAsepticProcedureList.forEach((asepticProcedureArray: any, index) => {
      if (index == 0) {
        this.asepticProcedures.forEach((procedure, index) => {
          if (procedure.checked) {
            data.categoryAxis.categories.push(this.layoutService.translateText(procedure.value));
          }
        });
      }
      if (asepticProcedureArray.observeEvaluationAsepticProcedureResult.length !== 0) {
        asepticProcedureArray.observeEvaluationAsepticProcedureResult.forEach((asepticProcedure: any) => {
          if (asepticProcedureArray.isBenchMark) {
            benchmarkCount++;
            name = asepticProcedure.departmentName !== null ?
              this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ` + this.layoutService.translateText(asepticProcedure.departmentName) :
              this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ` + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');
          } else {
            filterCount++;
            name = asepticProcedure.departmentName !== null ?
              this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ` + this.layoutService.translateText(asepticProcedure.departmentName) :
              this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ` + this.layoutService.translateText('EVALUATION.All.DEPARTMENTS');
          }

          let procedureData = [
            asepticProcedure.ventilationPercentage,
            asepticProcedure.preparationPercentage,
            asepticProcedure.manipulationPercentage,
            asepticProcedure.changeOfDressingPercentage,
            asepticProcedure.puncturesPercentage,
            asepticProcedure.contactPercentage,
            asepticProcedure.notSpecifiedPercentage
          ].filter((_, idx) => this.asepticProcedures[idx].checked);

          data.series.push({
            data: procedureData,
            name: name,
            type: 'column',
            color: colors[index],
            width: 20
          });
        });
      }

    })

    data.seriesDefaults.style = "smooth";
    data.seriesDefaults.labels = { visible: false }
    data.categoryAxis.rotation = 0;
    data.categoryAxis.maxDivisions = 10;

    if (data.length == 0 || data.series.length == 0) {
      this.noAsepticProcedures = true;
      this.asepticProceduresFilterChart.noDataFound = true;
    }

    this.asepticProceduresFilterChart.chartOptions = data;
    this.asepticProceduresFilterChart.chartDatamani();

    this.sopReportExport.chartAsepticProcedures = JSON.parse(JSON.stringify(this.asepticProceduresFilterChart.chartOptions));
    this.sopReportExport.breakChartAll();
  }

  buildObservePredefinedCommentsChart(res) {
    let data = JSON.parse(JSON.stringify(this.observeCommentsFilterChart.chartOptions));
    let dataSet = 0;
    let dataSetsName = this.layoutService.translateText('EVALUATION.DATA_SETS');
    data.categoryAxis.categories = [];
    data.series = [];

    let filterCount = 0;
    let benchmarkCount = 0;

    for (let i = 0; i < res.length; i++) {
      const predefinedCommentsList = res[i].observationPredefinedComments;
      for (let j = 0; j < predefinedCommentsList.length; j++) {
        const predefinedComment = predefinedCommentsList[j];
        if (new RegExp(this.commentTranslations.jewelleryComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.jewelleryComments.length; k++) {
            res[i].observationPredefinedComments[j].commentName = res[i].observationPredefinedComments[j].commentName.replace(this.commentTranslations.jewelleryComments[k], this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH'))
          }
        }
        if (new RegExp(this.commentTranslations.nailComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.nailComments.length; k++) {
            res[i].observationPredefinedComments[j].commentName = res[i].observationPredefinedComments[j].commentName.replace(this.commentTranslations.nailComments[k], this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH'))
          }
        }
        if (new RegExp(this.commentTranslations.desinfectionComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.desinfectionComments.length; k++) {
            res[i].observationPredefinedComments[j].commentName = res[i].observationPredefinedComments[j].commentName.replace(this.commentTranslations.desinfectionComments[k], this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED'))
          }
        }
        if (new RegExp(this.commentTranslations.antisepsisComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.antisepsisComments.length; k++) {
            res[i].observationPredefinedComments[j].commentName = res[i].observationPredefinedComments[j].commentName.replace(this.commentTranslations.antisepsisComments[k], this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED'))
          }
        }
        if (new RegExp(this.commentTranslations.processComments.join("|")).test(predefinedComment.commentName)) {
          for (let k = 0; k < this.commentTranslations.processComments.length; k++) {
            res[i].observationPredefinedComments[j].commentName = res[i].observationPredefinedComments[j].commentName.replace(this.commentTranslations.processComments[k], this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED'))
          }
        }
      }

    }

    var isBenchmark = false;
    for (const commentArray of res) {
      if (commentArray.isBenchMark) {
        isBenchmark = true;
        break;
      }
    }

    var colors = [];
    if (isBenchmark) {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    } else {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    }

    res.forEach((commentArray: any, index) => {
      dataSet = 0;
      data.series[index] = { data: [], name: [] };
      data.series[index].color = colors[index];

      if (commentArray.observationPredefinedComments.length === 0) {
        this.noObserveComments = true;
        this.observeCommentsFilterChart.noDataFound = true;
      } else {
        this.noObserveComments = false;
        this.observeCommentsFilterChart.noDataFound = false;
      }

      commentArray.observationPredefinedComments.forEach((comment: any) => {
        dataSet += comment.totalObservations;
        data.series[index].data.push(comment.predefinedCommentsPercentage);
        if (index == 0) {
          const title = this.layoutService.translateText(comment.commentName);
          data.categoryAxis.categories.push(title ? title : comment.commentName);

        }
      })

      if (commentArray.isBenchMark) {
        benchmarkCount++;
        data.series[index].name = [this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ${dataSet} ${dataSetsName}`];
      } else {
        filterCount++;
        data.series[index].name = [this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ${dataSet} ${dataSetsName}`];
      }
    });
    data.categoryAxis.rotation = 0;
    data.categoryAxis.maxDivisions = 10;
    this.observeCommentsFilterChart.chartOptions = data;
    this.observeCommentsFilterChart.chartDatamani();
    this.sopReportExport.chartObserveComments = JSON.parse(JSON.stringify(data));
    this.sopReportExport.breakChartAll();
  }


  changeLangProcessPage() {
    this.gridData.forEach((value, index) => {
      if (this.gridData[index].title)
        this.gridData[index].title = this.layoutService.translateText(value.title);
    });
  }

  selectFrequencyChartSeries(sopFilters) {
    if (sopFilters.selectedSeries != null) {
      var selectedSeries = new Set(JSON.parse(sopFilters.selectedSeries));
      if (selectedSeries.size != 0) {
        selectedSeries.forEach((serie) => {
          this.frequencyChart.internalToggleSerie({ index: serie });
          this.sopReportExport.frequencyChart.internalToggleSerie({ index: serie });
          this.sopReportExport.chartListFrequency.forEach((chart) => {
            chart.internalToggleSerie({ index: serie });
          });
        });
      }
    }
  }

  originalFrequencyFields: any = [];
  selectProcessComplianceSeries(sopFilters) {
    if (sopFilters.selectedSeries != null) {
      var selectedSeries = new Set(JSON.parse(sopFilters.selectedSeries));
      if (selectedSeries.size != 0) {
        selectedSeries.forEach((serie) => {
          this.processComplianceChart.internalToggleSerie({ index: serie });
          this.sopReportExport.processComplianceChart.internalToggleSerie({ index: serie });
          this.sopReportExport.chartListProcess.forEach((chart) => {
            chart.internalToggleSerie({ index: serie });
          });
        });

        this.originalFrequencyFields = this.fieldsFrequency;
        var filteredGroups = Array.from(selectedSeries).map((value: number) => `EVALUATION.FILTER_${value + 1}`);
        this.fieldsFrequency = this.originalFrequencyFields.filter((field) => {
          return !filteredGroups.some((group) => field.title.includes(group));
        });
      }
    }
  }

  selectSubStepProcessComplianceSeries(sopFilters) {
    if (sopFilters.selectedSeries != null) {
      var selectedSeries = new Set(JSON.parse(sopFilters.selectedSeries));
      if (selectedSeries.size != 0) {
        selectedSeries.forEach((serie) => {
          this.subStepProcessChart.internalToggleSerie({ index: serie });
          this.sopReportExport.subStepProcessChart.internalToggleSerie({ index: serie });
          this.sopReportExport.chartListSubstep.forEach((chart) => {
            chart.internalToggleSerie({ index: serie });
          });
        });
      }
    }
  }

  selectCommentSeries(sopFilters) {
    if (sopFilters.selectedSeries != null) {
      var selectedSeries = new Set(JSON.parse(sopFilters.selectedSeries));
      if (selectedSeries.size != 0) {
        selectedSeries.forEach((serie) => {
          this.predefinedCommentsChart.internalToggleSerie({ index: serie });
          this.sopReportExport.predefinedCommentsChart.internalToggleSerie({ index: serie });
          this.sopReportExport.chartListComments.forEach((chart) => {
            chart.internalToggleSerie({ index: serie });
          });
        });
      }
    }
  }

  selectOverallComplianceSeries(observeFilters) {
    if (observeFilters.selectedSeries != null) {
      var selectedSeries = new Set(JSON.parse(observeFilters.selectedSeries));
      if (selectedSeries.size != 0) {
        selectedSeries.forEach((serie) => {
          this.overallComplianceChart.internalToggleSerie({ index: serie });
          this.sopReportExport.overallCompliance.internalToggleSerie({ index: serie });
          this.sopReportExport.chartListOverallCompliance.forEach((chart) => {
            chart.internalToggleSerie({ index: serie });
          });
        });
      }
    }
  }

  selectFiveMomentsSeries(observeFilters) {
    if (observeFilters.selectedSeries != null) {
      var selectedSeries = new Set(JSON.parse(observeFilters.selectedSeries));
      if (selectedSeries.size != 0) {
        selectedSeries.forEach((serie) => {
          this.fiveMomentsFilterChart.internalToggleSerie({ index: serie });
          this.sopReportExport.fiveMoments.internalToggleSerie({ index: serie });
          this.sopReportExport.chartListFiveMoments.forEach((chart) => {
            chart.internalToggleSerie({ index: serie });
          });
        });
      }
    }
  }

  selectStaticsBeforeAsepticSeries(observeFilters) {
    if (observeFilters.selectedSeries != null) {
      var selectedSeries = new Set(JSON.parse(observeFilters.selectedSeries));
      if (selectedSeries.size != 0) {
        selectedSeries.forEach((serie) => {
          this.asepticProceduresFilterChart.internalToggleSerie({ index: serie });
          this.sopReportExport.asepticProcedures.internalToggleSerie({ index: serie });
          this.sopReportExport.chartListAsepticProcedures.forEach((chart) => {
            chart.internalToggleSerie({ index: serie });
          });
        });
      }
    }
  }

  buildFrequencyChart(res) {
    let data = JSON.parse(JSON.stringify(this.frequencyChart.chartOptions));
    let dataSet = 0;
    let dataSetsName = this.layoutService.translateText('EVALUATION.DATA_SETS');
    data.categoryAxis.categories = [];
    data.series = [];
    res = res.filter((item) => !item.isBenchMark)

    let filterCount: number = 0;
    let benchmarkCount: number = 0;

    var isBenchmark = false;
    for (const frequencyDistributionArray of res) {
      if (frequencyDistributionArray.isBenchMark) {
        isBenchmark = true;
        break;
      }
    }

    var colors = [];
    if (isBenchmark) {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    } else {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    }

    res.forEach((frequencyDistributionArray: any, index) => {
      dataSet = 0;
      data.series[index] = { data: [], name: [] }
      data.series[index].color = colors[index];

      if (frequencyDistributionArray.isBenchMark === false) {
        if (frequencyDistributionArray.subStepProcessComplianceList.length === 0) {
          this.noDataFound = true;
          this.frequencyChart.noDataFound = true;
        } else {
          this.noDataFound = false;
          this.frequencyChart.noDataFound = false;
        }
      }

      frequencyDistributionArray.subStepProcessComplianceList.forEach((frequencyDistribution: any) => {
        if (dataSet == 0) {
          dataSet = frequencyDistribution.totalObservations;
        }
        data.series[index].data.push(frequencyDistribution.processCompliancePercentage);
        if (index == 0) {
          data.categoryAxis.categories.push(this.layoutService.translateText(frequencyDistribution.stepName));
        }
      });

      if (frequencyDistributionArray.isBenchMark) {
        benchmarkCount++;
        data.series[index].name = [this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ${dataSet} ${dataSetsName}`];
      } else {
        filterCount++;
        data.series[index].name = [this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ${dataSet} ${dataSetsName}`];
      }

    });

    this.frequencyChart.chartOptions = data;
    this.frequencyChart.chartDatamani();
    this.sopReportExport.chartOptionsFrequency = JSON.parse(JSON.stringify(data));
    this.sopReportExport.breakChartAll();
  }

  buildSubStepProcessComplianceChart(res) {
    res = res.filter((item) => !item.isBenchMark);
    let data = JSON.parse(JSON.stringify(this.subStepProcessChart.chartOptions));
    let dataSet = 0;
    let dataSetsName = this.layoutService.translateText('EVALUATION.DATA_SETS');
    data.categoryAxis.categories = [];
    data.series = [];

    let filterCount: number = 0;
    let benchmarkCount: number = 0;

    let firstSubSetComplianceArrayWithData = res.find(subSetComplianceArray => subSetComplianceArray.subStepProcessComplianceList &&
      subSetComplianceArray.subStepProcessComplianceList.length > 0 && subSetComplianceArray.subStepProcessComplianceList[0].totalCompliantObservations !== 0);

    var isBenchmark = false;
    for (const subSetComplianceArray of res) {
      if (subSetComplianceArray.isBenchMark) {
        isBenchmark = true;
        break;
      }
    }

    var colors = [];
    if (isBenchmark) {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    } else {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    }

    res.forEach((subSetComplianceArray: any, index) => {
      dataSet = 0;
      data.series[index] = { data: [], name: [] }
      data.series[index].color = colors[index];

      if (subSetComplianceArray.isBenchMark == false) {
        if (subSetComplianceArray.subStepProcessComplianceList.length === 0) {
          this.nosubprocessFound = true;
          this.subStepProcessChart.noDataFound = true;
        } else {
          this.nosubprocessFound = false;
          this.subStepProcessChart.noDataFound = false;
        }
      }

      subSetComplianceArray.subStepProcessComplianceList.forEach((subSetCompliance: any, i) => {
        if (this.subStepProcessComplianceFilter.stepType == 0 ||
          (this.subStepProcessComplianceFilter.stepType == 1 && firstSubSetComplianceArrayWithData.subStepProcessComplianceList[i].isHygiene) ||
          (this.subStepProcessComplianceFilter.stepType == 2 && this.subStepProcessComplianceFilter.selectedSteps.length == 0) ||
          (this.subStepProcessComplianceFilter.stepType == 2 && this.subStepProcessComplianceFilter.selectedSteps.findIndex(res => res.stepCardId == subSetCompliance.stepCardId) != -1)) {
          if (dataSet == 0) {
            dataSet = subSetCompliance.totalObservations;
          }

          data.series[index].data.push({ value: subSetCompliance.processCompliancePercentage });
          if (index == 0) {
            this.subSetComplianceStepName(subSetCompliance, "OBSERVATION.BEFORE.TOUCHING_PATIENT"); //Before touching a patient
            this.subSetComplianceStepName(subSetCompliance, "OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1"); //"Before aseptic procedures");
            this.subSetComplianceStepName(subSetCompliance, "OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK"); //"After body fluid exposure risk");
            this.subSetComplianceStepName(subSetCompliance, "OBSERVATION.AFTER.TOUCHING_PATIENT"); //"After touching a patient");
            this.subSetComplianceStepName(subSetCompliance, "OBSERVATION.AFTER.TOUCHING_SURROUNDINGS"); //"After touching patient surroundings");
            data.categoryAxis.categories.push(this.layoutService.translateText(subSetCompliance.stepName));
          }
        }
      });

      if (subSetComplianceArray.isBenchMark) {
        benchmarkCount++;
        data.series[index].name = [this.layoutService.translate.instant('DASHBOARD.BENCHMARK') + ` ${benchmarkCount} - ${dataSet} ${dataSetsName}`];
      } else {
        filterCount++;
        data.series[index].name = [this.layoutService.translate.instant('EVALUATION.FILTER') + ` ${filterCount} - ${dataSet} ${dataSetsName}`];
      }

    });

    data.categoryAxis.rotation = 0;
    data.categoryAxis.maxDivisions = 10;
    this.subStepProcessChart.chartOptions = data;

    this.subStepProcessChart.chartOptions = JSON.parse(JSON.stringify(data));
    this.subStepProcessChart.chartDatamani();

    this.sopReportExport.chartOptionsSubstep = JSON.parse(JSON.stringify(data));
    this.sopReportExport.breakChartAll()
  }

  subSetComplianceStepName(subSetCompliance, translatetext) {
    if (subSetCompliance.stepName.includes(translatetext)) {
      var array = subSetCompliance.stepName.split(" (" + translatetext);
      if (array.length > 1) {
        var trimString = array[0];
        var mainstring = this.layoutService.translateText(trimString).toString();
        subSetCompliance.stepName = subSetCompliance.stepName.replace(trimString, mainstring);
      }
      var string = this.layoutService.translateText(translatetext).toString();
      subSetCompliance.stepName = subSetCompliance.stepName.replace(translatetext, string);
    }
  }

  emitData(valve) {
    this.childData.emit(valve)
  }

  downloadReport() {
    const currentDate = new Date();
    const format = 'pdf';
    const month = (currentDate.getMonth() + 1 > 9) ? currentDate.getMonth() + 1 : ('0' + (currentDate.getMonth() + 1));
    const date = (currentDate.getDate() > 9) ? currentDate.getDate() : '0' + currentDate.getDate();
    const fileName = `${currentDate.getFullYear()}.${month}.${date}_${this.layoutService.translateText('EVALUATION.SUMMARISED_REPORT_OK')}.${format}`;
    this.sopReportExport.pdf.saveAs(fileName);
  }

  saveReport() {
    this.sopReportExport.pdf.saveAs(this.layoutService.translateText('EVALUATION.SUMMARISED_REPORT_OK') + '.pdf');
  }

  checkEvalMode() {
    this.isObserve = (this.roleId == 1 || this.roleId == 2 || this.roleId == 3 || this.layoutService.isObserveLicense(this.packageID));
    this.isSOP = (this.roleId == 1 || this.roleId == 2 || this.roleId == 3 || this.layoutService.isMyHygieneSOPLicense(this.packageID));
    this.isCheck = (this.roleId == 1 || this.roleId == 2 || this.roleId == 3 || this.layoutService.isHygieneCheckLicense(this.packageID));
  }

  getMaxFilters(gridData): number {
    let max = 0;
    gridData.forEach(grid => {
      const count = this.getNumberOfFilters(grid);
      if (count > max) max = count;
    });
    return max;
  }

  getNumberOfFilters(grid: any): number {
    let count = 0;
    for (let i = 1; i <= 6; i++) {
      if (grid[`totalObservationsforfilter${i}`] !== undefined) {
        count++;
      }
    }
    return count;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  resetExportAs(value: string) {
    if (value === 'excel') {
      this.clickExcelBtn = false;
    }
  }
}
